<template>
  <div class="mt-res-report-options">
    <div
        class="mt-res-report-options__option"
        v-for="option in options"
        :key="option.variant"
    >
      <div
          v-if="view_download_html"
          class="mt-res-report-options__option-title-admin"
          @click="downloadHTML(option.variant)"
      >
        {{ option.title }}
      </div>
      <div
          v-else
          class="mt-res-report-options__option-title"
      >
        {{ option.title }}
      </div>

      <mt-checkbox
          class="mt-res-report-options__option-action"
          v-model="option.selected"
      />
    </div>
  </div>
</template>

<script>
import mtCheckbox from '@/components/UI/mtCheckbox/index.vue';
import {mapGetters} from "vuex";

export default {
  components: {
    mtCheckbox,
  },
  emits: ['downloadHTML'],
  props: {
    options: {
      type: Array,
      default: () => ([]),
    },
    view_download_html: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['authUser', 'isAdmin']),
  },

  watch: {},
  methods: {
    /* GETTERS */
    /* SETTERS */
    /* HANDLERS */
    /* HELPERS */
    downloadHTML(variant) {
      this.$emit(
          'downloadHTML',
          {variant: variant
          }
      );
    },
  },

  created() {
  },
  mounted() {
  },
}
</script>

<style lang="scss">
.mt-res-report-options {
  margin-top: 20px;

  &__option {
    font-family: 'Mulish';
    font-style: normal;
    border: 1.5px solid #DFE0EB;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    margin-top: 5px;

    &:first-child {
      margin-top: 0;
    }

    &-title {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.15px;
      color: #000000;
      user-select: none;
    }

    &-title-admin {
      text-decoration: underline;
    }

    &-title-admin:hover {
      color: #00788c;
      cursor: pointer;
    }


    &-action {
    }
  }
}
</style>